<template>
  <div>
    <el-dialog
      class="modal"
      title="編輯商戶渠道"
      :visible.sync="editDataModal"
      width="800px"
    >
      <div v-if="editDataModal">
        <p>用戶: {{ currentData.customer_id }}[{{ currentData.user.name }}]</p>
        <!-- <p>渠道編號: {{ currentData.id }}</p> -->
        <el-input v-model="currentData.alias"></el-input>
        <el-tabs v-model="activeName">
          <el-tab-pane label="渠道撥款設定" name="0">
            <el-form
              inline
              :model="currentData"
              class="demo-form-inline"
              label-position="top"
            >
              <el-form-item label="撥款模式">
                <el-select
                  filterable
                  v-model="currentData.grant_type"
                  :placeholder="
                    currentData.grant_type == 2 ? 'T+11' : '撥款模式'
                  "
                >
                  <el-option label="T+3" :value="0"></el-option>
                  <el-option label="T+11" :value="1"></el-option>
                  <!-- <el-option label="T+11" :value="2"></el-option> -->
                  <el-option label="T+0" :value="3"></el-option>
                  <el-option label="T+1" :value="4"></el-option>
                  <el-option label="T+2" :value="5"></el-option>
                  <!-- <el-option label="萊爾富" :value="3"></el-option> -->
                </el-select>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="額度限制設定" name="1">
            <el-form
              inline
              :model="currentData"
              class="demo-form-inline"
              label-position="top"
            >
              <el-form-item label="最小限額">
                <el-input
                  type="number"
                  v-model="currentData.lower_limit"
                  placeholder="最小限額"
                ></el-input>
              </el-form-item>
              <el-form-item label="最大限額">
                <el-input
                  type="number"
                  v-model="currentData.upper_limit"
                  placeholder="最大限額"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="費率細項設定" name="2">
            <p class="text-danger">
              [商戶手續費 = 高代費 + 代理費]
            </p>
            <el-form
              inline
              :model="currentData"
              class="demo-form-inline"
              label-position="top"
            >
              <el-form-item label="商戶手續費(末端百分比)">
                <el-input
                  type="number"
                  v-model="currentData.fee_rate_f"
                  placeholder="商戶手續費"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="高代費(百分比)">
                <el-input
                  type="number"
                  v-model="currentData.agent_rate_f"
                  placeholder="高代費"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="渠道費(百分比)">
                <el-input
                  type="number"
                  v-model="currentData.cost_rate_f"
                  placeholder="渠道費"
                ></el-input>
              </el-form-item> -->
              <!-- <el-form-item label="平台費(百分比)">
                <el-input
                  disabled
                  :value="
                    currentData
                      ? currentData.agent
                        ? currentData.agent.system_rate_f
                        : ''
                      : ''
                  "
                  placeholder="平台費"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="商戶手續費(末端單筆)">
                <el-input
                  min="0"
                  onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
                  type="number"
                  v-model="currentData.fee_add_f"
                  placeholder="商戶手續費"
                ></el-input>
              </el-form-item>
              <el-form-item label="高代費(單筆)">
                <el-input
                  min="0"
                  onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
                  type="number"
                  v-model="currentData.agent_add_f"
                  placeholder="高代費"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="渠道費(單筆)">
                <el-input
                  min="0"
                  onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
                  type="number"
                  v-model="currentData.cost_add_f"
                  placeholder="渠道費"
                ></el-input>
              </el-form-item> -->
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="代理(中人)費率設定" name="3">
            <el-form
              inline
              :model="currentData"
              class="demo-form-inline"
              label-position="top"
              v-for="subagent in currentData.subagent_methods"
              :key="subagent.id"
            >
              <el-form-item label="代理">
                <el-input
                  disabled
                  :value="subagent.user.id + '-' + subagent.user.name"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="
                  subagent.subagent_rate_f != '無' &&
                    subagent.subagent_add_f != '無'
                "
                label="代理費"
              >
                <el-input
                  type="number"
                  v-model="subagent.subagent_rate_f"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="
                  subagent.subagent_rate_f != '無' &&
                    subagent.subagent_add_f != '無'
                "
                label="代理費(單筆)"
              >
                <el-input
                  min="0"
                  onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
                  type="number"
                  v-model="subagent.subagent_add_f"
                ></el-input>
              </el-form-item>
              <el-form-item label="操作">
                <el-button
                  @click="
                    subagent.subagent_rate_f = '無';
                    subagent.subagent_add_f = '無';
                  "
                  v-if="
                    subagent.subagent_rate_f != '無' &&
                      subagent.subagent_add_f != '無'
                  "
                  size="mini"
                  type="danger"
                  >刪除</el-button
                >
                <el-button
                  v-if="
                    subagent.subagent_rate_f == '無' ||
                      subagent.subagent_add_f == '無'
                  "
                  size="mini"
                  type="primary"
                  @click="
                    subagent.subagent_rate_f = 0;
                    subagent.subagent_add_f = 0;
                  "
                  >新增</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editDataModal = false" class="btn">取消</div>
        <div @click="confirmEdit" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="渠道設定"
      :visible.sync="addModal"
      width="800px"
    >
      <el-form
        inline
        :model="addData"
        class="demo-form-inline"
        label-position="top"
      >
        <el-form-item label="商戶號">
          <el-select
            filterable
            v-model="addData.customer_id"
            placeholder="商戶號"
          >
            <el-option
              :label="customer"
              :value="customer"
              v-for="customer in customerList"
              :key="customer"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select filterable placeholder="渠道" v-model="addData.id">
            <el-option
              :label="agent.alias"
              :value="agent.id"
              v-for="agent in unbindAgentList"
              :key="agent.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <h2>[渠道撥款設定]</h2>
      <el-form
        inline
        :model="addData"
        class="demo-form-inline"
        label-position="top"
      >
        <el-form-item label="撥款模式">
          <el-select
            filterable
            v-model="addData.grant_type"
            :placeholder="'撥款模式'"
          >
            <el-option label="T+3" value="0"></el-option>
            <el-option label="T+11" value="1"></el-option>
            <!-- <el-option label="T+11" value="2"></el-option> -->
            <el-option label="T+0" :value="3"></el-option>
            <el-option label="T+1" :value="4"></el-option>
            <el-option label="T+2" :value="5"></el-option>
            <!-- <el-option label="萊爾富" value="3"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
      <h2>[額度限制設定]</h2>
      <el-form
        inline
        :model="addData"
        class="demo-form-inline"
        label-position="top"
      >
        <el-form-item label="最小限額(0表示不限制)">
          <el-input
            type="number"
            v-model="addData.lower_limit"
            placeholder="最小限額"
          ></el-input>
        </el-form-item>
        <el-form-item label="最大限額(0表示不限制)">
          <el-input
            type="number"
            v-model="addData.upper_limit"
            placeholder="最大限額"
          ></el-input>
        </el-form-item>
      </el-form>
      <h2>[費率細項設定]</h2>
      <p class="text-danger">
        [商戶手續費 = 高代費 + 代理費]
      </p>
      <el-form
        inline
        :model="addData"
        class="demo-form-inline"
        label-position="top"
      >
        <el-form-item label="商戶手續費(末端百分比)">
          <el-input
            type="number"
            v-model="addData.fee_rate"
            placeholder="商戶手續費"
          ></el-input>
        </el-form-item>
        <el-form-item label="高代費(百分比)">
          <el-input
            type="number"
            v-model="addData.agent_rate"
            placeholder="高代費"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="渠道費(百分比)">
          <el-input
            type="number"
            v-model="addData.cost_rate"
            placeholder="渠道費"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="平台費(百分比)">
          <el-input
            disabled
            :value="system_rate"
            placeholder="平台費"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="商戶手續費(末端單筆)">
          <el-input
            min="0"
            onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
            type="number"
            v-model="addData.fee_add"
            placeholder="商戶手續費"
          ></el-input>
        </el-form-item>
        <el-form-item label="高代費(單筆)">
          <el-input
            min="0"
            onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
            type="number"
            v-model="addData.agent_add"
            placeholder="高代費"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="渠道費(單筆)">
          <el-input
            min="0"
            onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
            type="number"
            v-model="addData.cost_add"
            placeholder="渠道費"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <h2>[代理(中人)費率設定]</h2>
      <el-form
        inline
        :model="addData"
        class="demo-form-inline"
        label-position="top"
        v-for="(subagent, key) in addData.subAgentList"
        :key="key"
      >
        <el-form-item label="代理">
          <el-select
            filterable
            placeholder="代理"
            v-model="subagent.subagent_id"
          >
            <el-option
              :label="agent.subagent_id"
              :value="agent.subagent_id + '-' + agent.id"
              v-for="agent in returnList(subAgentList)"
              :key="agent.subagent_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理費">
          <el-input type="number" v-model="subagent.subagent_rate"></el-input>
        </el-form-item>
        <el-form-item label="代理費(單筆)">
          <el-input
            min="0"
            onkeyup="value=value.replace(/^(-1+)|[^\d]+/g,'')"
            type="number"
            v-model="subagent.subagent_add"
          ></el-input>
        </el-form-item>
        <el-form-item label="操作">
          <el-button
            @click="addData.subAgentList.push({})"
            v-if="
              addData.subAgentList.length < subAgentList.length &&
                key == addData.subAgentList.length - 1
            "
            size="mini"
            type="primary"
            >新增</el-button
          >
          <el-button
            @click="addData.subAgentList.splice(key, 1)"
            v-if="addData.subAgentList.length > 1"
            size="mini"
            type="danger"
            >刪除</el-button
          >
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="addModal = false" class="btn">取消</div>
        <div @click="confirmAdd" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      :title="'修改' + switchData.editTitle"
      :visible.sync="editSwitchModal"
      width="375px"
    >
      <div>
        確認{{ currentData[currentData.assign] == 1 ? "關閉" : "開啟" }}
        {{ currentData.alias }} ?
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editSwitchModal = false" class="btn">取消</div>
        <div @click="confirmEditSwitch" class="btn">確認</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="商戶號/用戶名">
        <el-input
          v-model="searchData.search"
          placeholder="商戶號/用戶名"
        ></el-input>
      </el-form-item>
      <el-form-item label="三方渠道">
        <el-select v-model="searchData.method_id" placeholder="三方渠道">
          <el-option label="全部" value=""></el-option>
          <el-option
            :label="method.name"
            :value="method.id"
            v-for="method in methodList"
            :key="method.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <el-button size="mini" @click="addChannel">渠道設定</el-button>
    <el-table
      stripe
      :data="dataList"
      border
      style="width: 100%;margin-top:18px"
    >
      <!-- <el-table-column
        :key="1"
        header-align="center"
        align="center"
        prop="id"
        label="渠道編號"
      >
      </el-table-column> -->
      <el-table-column
        v-if="
          $store.state.userStatus != 'agent' &&
            $store.state.userStatus != 'subAgent'
        "
        :key="2"
        header-align="center"
        align="center"
        prop="agent_id"
        label="高代號"
      >
      </el-table-column>
      <el-table-column
        :key="10"
        header-align="center"
        align="center"
        prop="customer_id"
        label="商戶號"
      >
      </el-table-column>
      <el-table-column
        :key="3"
        header-align="center"
        align="center"
        prop="type_alias"
        label="用戶名稱"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            {{ scope.row.user.name }}
          </div>
        </template> </el-table-column
      ><el-table-column
        :key="9"
        header-align="center"
        align="center"
        prop="type_alias"
        label="渠道測試"
        width="200"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              size="mini"
              v-if="scope.row.status == 1"
              class="btn btn-green"
              @click="uuid(scope.row.uuid)"
            >
              前往
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :key="6"
        header-align="center"
        align="center"
        prop="alias"
        label="渠道名稱"
      >
      </el-table-column>
      <el-table-column
        :key="8"
        header-align="center"
        align="center"
        prop="type_alias"
        label="費率設定"
        width="200"
      >
        <template slot-scope="scope">
          <div>
            <el-button size="mini" @click="editData(scope.row)"
              >查看費率</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :key="7"
        header-align="center"
        align="center"
        prop="type_alias"
        label="啟用狀態"
      >
        <template slot-scope="scope">
          <div>
            <el-switch
              @change="changeSwitch(scope.row, 'status', '啟用狀態')"
              :value="scope.row.status == 1"
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-if="$permission('collectionMethod.customers.updateStatus')"
            >
            </el-switch>
            <p v-else>{{ scope.row.status == 1 ? "開啟" : "關閉" }}</p>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        :current-page.sync="page"
        layout="prev, pager, next"
        :page-count="pagination.total_page"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "1",
      searchData: {},
      methodList: [],
      saveData: false,
      inSearch: false,
      page: 1,
      dataList: [],
      pagination: {},
      currentData: {},
      editSwitchModal: false,
      switchData: {},
      editDataModal: false,
      addModal: false,
      customerList: [],
      addData: {},
      unbindAgentList: [],
      subAgentList: [],
      system_rate: ""
    };
  },
  watch: {
    "addData.customer_id"() {
      if (
        this.addData.customer_id == "" ||
        this.addData.customer_id.length < 5 ||
        this.addData.customer_id.length > 5
      )
        return;
      this.$http
        .get(
          `/back/collection_method/customers/unset/${this.addData.customer_id}`
        )
        .then(res => {
          if (res.data.code != 0) {
            return;
          }
          this.$http
            .get(`/back/customers/${this.addData.customer_id}/bind`)
            .then(res => {
              if (res.data.code == 0) {
                this.subAgentList = res.data.data;
              }
            });
          this.unbindAgentList = res.data.data.method;
          this.system_rate = 0;
          // this.system_rate = res.data.data.system_rate;
          this.addData.subAgentList = [
            {
              customer_subagent_id: "",
              subagent_rate: "",
              subagent_add: "",
              subagent_id: ""
            }
          ];
        });
    },
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    uuid(uuid) {
      window.open(`${process.env.VUE_APP_DEFAULT_CTC}demo_code?code=${uuid}`);
    },
    confirmAdd() {
      let sendData = this.addData;
      let agent_add;
      sendData.customer_subagent_id = [];
      sendData.subagent_rate = [];
      sendData.subagent_add = [];
      sendData.subagent_id = [];
      this.addData.subAgentList.forEach(list => {
        if (
          list.subagent_id != "" &&
          list.subagent_id &&
          list.subagent_rate !== ""
        ) {
          agent_add = agent_add * 1 - list.subagent_add * 1;
          sendData.customer_subagent_id.push(list.subagent_id.split("-")[1]);
          sendData.subagent_id.push(list.subagent_id.split("-")[0]);
          sendData.subagent_add.push(list.subagent_add);
          sendData.subagent_rate.push(list.subagent_rate);
        }
      });
      let data = {};
      data = {
        agent_method_id: sendData.id,
        fee_rate: sendData.fee_rate,
        customer_subagent_id: sendData.customer_subagent_id,
        subagent_id: sendData.subagent_id,
        subagent_rate: sendData.subagent_rate,
        subagent_add: sendData.subagent_add,
        fee_add: sendData.fee_add,
        agent_add: sendData.agent_add,
        cost_rate: 0,
        // cost_rate: sendData.cost_rate,
        cost_add: 0,
        // cost_add: sendData.cost_add,
        agent_rate: sendData.agent_rate,
        customer_id: sendData.customer_id,
        upper_limit: sendData.upper_limit,
        lower_limit: sendData.lower_limit,
        grant_type: sendData.grant_type
      };
      this.$http.post(`/back/collection_method/customers`, data).then(res => {
        if (res.data.code == 0) {
          this.getData();
          this.$message.success("成功");
          this.addModal = false;
        }
      });
    },
    returnList(list) {
      return list;
      // let have = this.addData.subAgentList.map(e => {
      //   return e.subagent_id;
      // });
      // return list.filter(e => {
      //   return have.indexOf(e.subagent_id) == -1;
      // });
    },
    checKAgent(id) {
      if (
        this.addData.subAgentList
          .map(e => {
            console.log(e, "this.addData.subAgentList");
            return e.subagent_id;
          })
          .indexOf(String(id)) == -1
      ) {
        return true;
      }
      return false;
    },
    addChannel() {
      this.$http
        .get(`/back/users?role_name=customer&status=1&paginate=0`)
        .then(res => {
          if (res.data.code == 0) {
            this.customerList = res.data.data;
            this.addModal = true;
            this.addData = {
              subAgentList: [
                {
                  customer_subagent_id: "",
                  subagent_rate: "",
                  subagent_add: "",
                  subagent_id: ""
                }
              ]
            };
          }
        });
    },
    confirmEdit() {
      let subagent_rate = [];
      let subagent_add = [];
      let subagent_id = [];
      let customer_subagent_id = [];
      let data;
      this.currentData.subagent_methods.forEach(user => {
        if (user.subagent_rate_f != "無") {
          subagent_id.push(user.user.id);
          subagent_rate.push(user.subagent_rate_f);
          subagent_add.push(user.subagent_add_f);
          customer_subagent_id.push(user.customer_subagent_id);
        }
      });
      data = {
        agent_add: this.currentData.agent_add_f,
        fee_add: this.currentData.fee_add_f,
        cost_add: 0,
        // cost_add: this.currentData.cost_add_f,
        cost_rate: 0,
        // cost_rate: this.currentData.cost_rate_f,
        fee_rate: this.currentData.fee_rate_f,
        customer_id: this.currentData.user.id,
        upper_limit: this.currentData.upper_limit,
        lower_limit: this.currentData.lower_limit,
        customer_subagent_id,
        subagent_id,
        subagent_rate,
        subagent_add,
        agent_rate: this.currentData.agent_rate_f,
        grant_type: this.currentData.grant_type
      };
      data.alias = this.currentData.alias;
      this.$http
        .put(`/back/collection_method/customers/${this.currentData.id}`, data)
        .then(res => {
          if (res.data.code == 0) {
            this.getData();
            this.$message.success("成功");
            this.editDataModal = false;
          }
        });
    },
    editData(data) {
      let currentData = JSON.parse(JSON.stringify(data));
      currentData.fee_add_f = Math.trunc(currentData.fee_add_f);
      currentData.agent_add_f = Math.trunc(currentData.agent_add_f);
      currentData.cost_add_f = Math.trunc(currentData.cost_add_f);
      this.currentData = currentData;
      this.editDataModal = true;
    },
    confirmEditSwitch() {
      this.$http
        .put(
          `/back/collection_method/customers/${this.currentData.id}/status`,
          {
            status: this.currentData[this.currentData.assign] == 1 ? 0 : 1
          }
        )
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.getData();
            this.editSwitchModal = false;
          }
        });
    },
    changeSwitch(data, assign, title, api) {
      this.currentData = JSON.parse(JSON.stringify(data));
      this.currentData.assign = assign;
      this.currentData.api = api;
      this.switchData.editTitle = title;
      this.editSwitchModal = true;
      if (this.currentData.role_name == "customer" && title != "啟用狀態") {
        this.currentData[assign] = this.currentData.customer[assign];
      }
    },
    getMethodList() {
      this.$http.get(`/back/methods/select`).then(res => {
        if (res.data.code == 0) {
          this.methodList = res.data.data;
        }
      });
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .get(`/back/collection_method/customers`, { params: searchData })
        .then(res => {
          if (res.data.code == 0) {
            // if (res.data.data.length == 0) {
            //   context.commit("CUSTOMERC", res.data);
            //   return;
            // }
            if (res.data.data[0] && res.data.data[0].customer_subagents) {
              res.data.data.forEach(customer => {
                customer.customer_subagents.forEach(unbindSubagent => {
                  let have = false;
                  customer.subagent_methods.forEach(bindSubagent => {
                    bindSubagent.subagent_add_f = Math.trunc(
                      bindSubagent.subagent_add_f
                    );
                    if (
                      unbindSubagent.user_subagent.id == bindSubagent.user.id
                    ) {
                      have = true;
                      return;
                    }
                  });
                  if (!have) {
                    customer.subagent_methods.push({
                      subagent_rate_f: "無",
                      subagent_add_f: "無",
                      customer_subagent_id: unbindSubagent.id,
                      user: {
                        id: unbindSubagent.user_subagent.id,
                        name: unbindSubagent.user_subagent.name
                      }
                    });
                  }
                });
              });
            }
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
          }
        });
    }
  },
  created() {
    this.getData();
    this.getMethodList();
  }
};
</script>
